import { GameService } from './game.service';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IFindContentFilter,
  LegacyContent,
  ILikeDislikeResponse,
  IContentStats,
  User,
  getContentInstanceByItem,
  ContentDetailsType,
  IContentBlock,
  SubjectsRegistry,
} from 'lingo2-models';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export type ContentBlockType = IContentBlock<LegacyContent, IFindContentFilter>;

export interface IContentStatsResponse extends IContentStats {
  /** @see PublishStatusEnum */
  [key: string]: number;
  template: number;
  total: number;
}

interface IChangedStats {
  id: string;
  stats: Partial<IContentStats>;
}

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  public change = new BehaviorSubject<IChangedStats>({id: '', stats: {}});
  public change$ = this.change.asObservable();

  public constructor(
    private http: HttpClient,
    private gameService: GameService,
  ) {}

  /**
   * Поиск записи по ID
   */
  public getById(id: string, full = false, details?: ContentDetailsType[]) {
    const url = `https://${this.gameService.host}/web/content/content/${id}`;
    let params = new HttpParams().set('full', full ? '1' : '0');
    if (details && details.length) {
      params = params.set('details', JSON.stringify(details));
    }
    return this.http.get(url, { params, observe: 'response' }).pipe(
      map(this.handleContentResponse),
      // catchError(this.handleError),
    );
  }

  /**
   * Поставить лайк
   */
  public like(id: string): Observable<ILikeDislikeResponse> {
    const url = `https://${this.gameService.host}/web/content/content/${id}/like`;
    return this.http.post<ILikeDislikeResponse>(url, {}, { observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }

  /**
   * Поставить дизлайк
   */
  public dislike(id: string): Observable<ILikeDislikeResponse> {
    const url = `https://${this.gameService.host}/web/content/content/${id}/dislike`;
    return this.http.post<ILikeDislikeResponse>(url, {}, { observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }

  /**
   * Убрать лайк/дизлайк
   */
  public unLike(id: string): Observable<ILikeDislikeResponse> {
    const url = `https://${this.gameService.host}/web/content/content/${id}/like`;
    return this.http.delete<ILikeDislikeResponse>(url, { observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }

  public getSubjectsV2(locale: string, all = false): Observable<SubjectsRegistry> {
    const url = `https://${this.gameService.host}/web/content/reference/subjects/2`;
    const params = new HttpParams()
      .set('locale', locale)
      .set('all', all ? '1' : '0')
      .set('v', Date.now());
    return this.http.get<SubjectsRegistry>(url, { params, observe: 'response' }).pipe(
      map((response) => response.body!),
      // catchError(this.handleError),
    );
  }

  private handleContentResponse(response: HttpResponse<any>) {
    return getContentInstanceByItem(response.body);
  }
}
